import $ from 'jquery';
import UIkit from 'uikit';
window.addEventListener('px-ready',function(){
    //console.log('a');
    /*UIkit.accordion('beforeshow',function(){
        console.log('b');
        console.log($(this).find('.uk-accordion-title').html());
    })*/
    $('.uk-accordion-title').click(function(){
        var clickedel = $(this)
        window.setTimeout(function(){
            $([document.documentElement, document.body]).animate({
                scrollTop: clickedel.offset().top-200
            }, 500);
        },200)
    })
})